"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllDivisionsRequest = void 0;
var GetAllDivisionsRequest = /** @class */ (function () {
    function GetAllDivisionsRequest() {
    }
    return GetAllDivisionsRequest;
}());
exports.GetAllDivisionsRequest = GetAllDivisionsRequest;
;
//# sourceMappingURL=getAllDivisions.request.js.map